<mat-chip
  (click)="$event.stopPropagation()"
  (focus)="$event.stopPropagation()"
  class="mat-chip"
  [disabled]="loading"
  [removable]="
    (isChipOptional() ||
      isChipPreselected() ||
      isChipChiningParams() ||
      isChipDefault()) &&
    !loading
  "
  (removed)="remove(selectedData)"
>
  <label class="has-float-label">
    <input
      #chipInput
      (focus)="inputFocusOn = true && !loading"
      (blur)="inputFocusOn = false"
      matInput
      [formControl]="slider"
      [readonly]="true"
      type="number"
      class="chip-input"
      (keydown)="$event.stopImmediatePropagation()"
      [placeholder]="placeholders[0]"
      style="margin-bottom: 1px"
      [style.margin-bottom]="slider.value ? '6px' : '-20px'"
      attr.data-testid="cis_slider_input_{{
        selectedData?.name?.toLowerCase()?.replace(' ', '_')
      }}"
    />
    <div class="label">{{ selectedData?.name ?? '' | translate }}</div>
  </label>

  <button
    [disabled]="isChipLock() || isChipChiningParams() || loading"
    mat-icon-button
    matSuffix
    (click)="$event.stopImmediatePropagation(); onSliderBtnClick()"
    style="margin-right: -15px"
    [matTooltip]="openSlider ? 'Close Slider' : 'Open Slider'"
    attr.data-testid="cis_slider_{{
      selectedData?.name?.toLowerCase()?.replace(' ', '_')
    }}_btn_toggle_slider"
  >
    @if (!openSlider) {
    <mat-icon
      attr.data-testid="cis_slider_{{
        selectedData?.name?.toLowerCase()?.replace(' ', '_')
      }}_btn_open_slider"
      [style.margin-top]="slider.value ? '30px' : '10px'"
    >
      keyboard_arrow_down</mat-icon
    >
    } @if (openSlider) {
    <mat-icon
      [style.margin-top]="slider.value ? '30px' : '10px'"
      attr.data-testid="cis_slider_{{
        selectedData?.name?.toLowerCase()?.replace(' ', '_')
      }}_btn_close_slider"
    >
      keyboard_arrow_up</mat-icon
    >
    }
  </button>

  @if (openSlider) {
  <mat-card appearance="outlined" class="slider-card">
    <div>
      <label
        attr.data-testid="cis_slider_{{
          selectedData?.name?.toLowerCase()?.replace(' ', '_')
        }}_label_{{ min }}"
        style="left: 0"
        >{{ min }}</label
      >
      <label
        attr.data-testid="cis_slider_{{
          selectedData?.name?.toLowerCase()?.replace(' ', '_')
        }}_label_{{ max }}"
        style="float: right"
        >{{ max }}</label
      >
    </div>
    <!-- TODO: The 'tickInterval' property no longer exists -->
    <!-- [thumbLabel]="true" line removed because it's not support for angular 15-->
    <mat-slider
      style="margin-top: -14px"
      [ngStyle]="styleObject()"
      [min]="min"
      [max]="max"
      [step]="stepSize"
      aria-label="units"
      attr.data-testid="cis_slider_{{
        selectedData?.name?.toLowerCase()?.replace(' ', '_')
      }}"
      #ngSlider
      ><input
        matSliderThumb
        [value]="slider.value || 0"
        (input)="
          sliderValueChange({
            source: ngSliderThumb,
            parent: ngSlider,
            value: ngSliderThumb.value
          })
        "
        #ngSliderThumb="matSliderThumb"
    /></mat-slider>
  </mat-card>
  } @if ( isChipOptional() || isChipPreselected() || isChipChiningParams() ||
  isChipDefault() ) {
  <mat-icon
    matChipRemove
    [style.cursor]="loading ? 'context-menu' : 'pointer'"
    style="vertical-align: text-top"
    attr.data-testid="cis_slider_{{
      selectedData?.name?.toLowerCase()?.replace(' ', '_')
    }}_btn_cancel"
    >cancel</mat-icon
  >
  } @if (isChipMandatory()) {
  <mat-icon
    style="vertical-align: text-top; cursor: default"
    attr.data-testid="cis_slider_{{
      selectedData?.name?.toLowerCase()?.replace(' ', '_')
    }}_icon_default"
    >push_pin</mat-icon
  >
  } @if (isChipLock()) {
  <mat-icon
    style="vertical-align: text-top; cursor: default"
    attr.data-testid="cis_slider_{{
      selectedData?.name?.toLowerCase()?.replace(' ', '_')
    }}_icon_locked"
    >lock</mat-icon
  >
  }
</mat-chip>
